import { SET_SORT } from '../mutationTypes';

const moduleSort = {
  namespaced: true,

  state: {
    activeSorts: {
      sort: null,
    },
  },

  getters: {

  },

  actions: {

  },

  mutations: {
    [SET_SORT](state, payload) {
      state.activeSorts.sort = payload;
    },
  },
};

export default moduleSort;
